import styled from "@emotion/styled";
import { TitleAProps } from "@src/ruix/types";

const TitleA = (props: TitleAProps) => {
	const size = props.size || "medium";
	const align = props.align || "left";
	const color = props.color;
	const subTitleColor = props.subTitleColor;
	const labelColor = props.labelColor;

	return (
		<TitleAComponent className={[size, align, color].join(" ")}>
			{props.label ? (
				<div
					className="title-a-label"
					style={{
						color: labelColor,
					}}
				>
					{props.label}
				</div>
			) : null}
			<div className="title-a-title">{props.title}</div>
			{props.subTitle ? (
				<div
					className={["title-a-sub-title"].join(" ")}
					style={{
						color: subTitleColor,
					}}
				>
					{props.subTitle}
				</div>
			) : null}
		</TitleAComponent>
	);
};

const TitleAComponent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 7px;

	&.left {
		align-items: flex-start;
	}

	&.center {
		align-items: center;
	}

	&.right {
		align-items: flex-end;
	}

	&.black {
		.title-a-label,
		.title-a-title,
		.title-a-sub-title {
			color: black;
		}
	}

	&.white {
		.title-a-label,
		.title-a-title,
		.title-a-sub-title {
			color: white;
		}
	}

	&.gray {
		.title-a-label,
		.title-a-title,
		.title-a-sub-title {
			color: var(--gray-darken);
		}
	}

	&.primary {
		.title-a-label,
		.title-a-title,
		.title-a-sub-title {
			color: var(--primary);
		}
	}

	&.disable {
		.title-a-label,
		.title-a-title,
		.title-a-sub-title {
			color: var(--disable);
		}
	}

	.title-a-label {
		line-height: 1;
	}

	.title-a-title {
		font-weight: bold;
		line-height: 1;
	}

	.title-a-sub-title {
		font-weight: 400;
		line-height: 1;
	}

	&.xsmall {
		.title-a-label {
			font-size: 10px;
		}
		.title-a-title {
			font-size: 18px;
		}
		.title-a-sub-title {
			font-size: 14px;
		}
	}

	&.small {
		.title-a-label {
			font-size: 12px;
		}
		.title-a-title {
			font-size: 20px;
		}

		.title-a-sub-title {
			font-size: 16px;
		}
	}

	&.medium {
		.title-a-label {
			font-size: 16px;
		}
		.title-a-title {
			font-size: 28px;
		}

		.title-a-sub-title {
			font-size: 20px;
		}
	}

	&.large {
		.title-a-label {
			font-size: 20px;
		}
		.title-a-title {
			font-size: 36px;
		}

		.title-a-sub-title {
			font-size: 24px;
		}
	}
`;

export default TitleA;
